<!-- eslint-disable no-console -->
// Edit Profile

<template>
  <div class="page-container justify-center pt-4 pb-5">
    <form
      id="lms1900"
      class="app-form lams-light border-main curved-1 shadow-dark"
      @submit.prevent
    >
      <Ul class="crumbs text-charcoal mb-3">
        <li><sym-link to="/">Home</sym-link></li>
        <li><sym-link :to="getPortalPagePath()">Portal</sym-link></li>
        <li><span aria-current="page">Edit Profile</span></li>
      </Ul>

      <div
        class="d-flex justify-between align-items-center lams p-2 curved-bottom mb-3"
      >
        <p class="mb-0 display-9 py-1">
          <i class="fa fa-edit fa-fw fa-lg mr-1"></i>Edit Profile
        </p>
      </div>

      <div
        class="short-help-box border-main mb-4 ivory curved sm-1 shadow-soft"
        v-show="profile.email !== profile.validEmail"
      >
        <p class="mb-2 text-justify">
          Verify that this is your email address <b> {{ profile.email }} </b> by
          clicking verify.
        </p>

        <div class="text-right">
          <button
            type="button"
            class="warning darken-2 sm-2 shadow"
            @click="onResendConfirmation()"
          >
            Verify
          </button>
        </div>
      </div>

      <div
        class="short-help-box border-main mb-4 ivory curved sm-1 shadow-soft"
        v-show="profile.phoneNumber !== profile.validPhoneNumber"
      >
        <p class="mb-2 text-justify">
          Verify that this is your mobile number
          <b> {{ profile.phoneNumber }} </b> by clicking verify.
        </p>

        <div class="text-right">
          <button
            type="button"
            class="warning darken-2 sm-2 shadow"
            @click="showSMSVerificationDialog()"
          >
            Verify
          </button>
        </div>
      </div>

      <sym-modal
        v-model="isSMSVerificationVisible"
        size="sm"
        :header="false"
        :customBody="true"
        :footer="false"
        :backdrop="false"
        v-if="isSMSVerificationVisible"
      >
        <div class="pos-relative1 board p-1 mb-0">
          <!-- <button class="close" @click="isVerificationVisible=false"><i class="fa fa-times"></i></button> -->
          <!-- <button class="close" @click="isSMSVerificationVisible=false"><i class="fa fa-times"></i></button> -->
          <button class="close" @click="hideSMSVerificationDialog()">
            <i class="fa fa-times"></i>
          </button>
          <div class="curved border-dark warning-light p-3 text-center">
            <i class="fa fa-shield fa-2x"></i>
            <p class="lg-3 mb-2 bold">Your phone number needs verification.</p>
            <!-- <p class="lg-2 mb-1">Check your verification code we sent on your number <b>VERIFY</b> button to confirm.</p> -->
            <p class="lg-2 mb-2">
              Check your verification code we sent to your number
              <b>VERIFY</b> button to confirm.
            </p>
            <!-- <sym-text class="w20" v-on:keydown="key" v-model="smsVerificationCode" plain align="bottom" cue="0000" type="tel"></sym-text> -->
            <input type="tel" v-model="OTP" placeholder="(OTP) 0000" />

            <div class="buttons mt-3" justify lg-1 shadow-soft>
              <button class="success text-center" @click="onVerifyCode()">
                <i class="fa fa-mobile-phone fa-lg mr-2"></i>Verify
              </button>
            </div>
            <div class="buttons mt-3" justify lg-1 shadow-soft>
              <button
                class="warning text-center"
                :disabled="isDisabled"
                @click="onResendOTP()"
              >
                <i class="fa fa-send-o fa-lg mr-2"></i> Request OTP ({{
                  countDown
                }})
              </button>
            </div>
          </div>
        </div>
      </sym-modal>

      <div :key="ts" v-show="isFilled">
        <button
          type="button"
          class="primary mb-3 w-100 text-center lg-2 p-1 shadow-soft"
          @click="goBack"
        >
          <i class="fa fa-arrow-left mr-2"></i>Back
        </button>

        <sym-text
          plain
          align="bottom"
          v-model="profile.lastName"
          caption="Last Name"
        ></sym-text>
        <sym-text
          plain
          align="bottom"
          v-model="profile.firstName"
          caption="First Name"
        ></sym-text>
        <sym-text
          plain
          align="bottom"
          v-model="profile.middleName"
          caption="Middle Name"
        ></sym-text>

        <div class="equal-width">
          <sym-text
            plain
            align="bottom"
            v-model="profile.shortName"
            caption="Short Name"
          ></sym-text>
          <sym-date
            plain
            align="bottom"
            v-model="profile.birthDate"
            caption="Birth Date"
            @changing="onBirthDateChanging"
          ></sym-date>
        </div>

        <sym-text
          plain
          align="bottom"
          v-model="profile.email"
          caption="Email Address"
          @changing="onEmailChanging"
        ></sym-text>
        <sym-text
          plain
          align="bottom"
          v-model="profile.phoneNumber"
          caption="Mobile Number (ex: 0921XXXXXXX)"
          cue="0921XXXXXXX"
          type="tel"
        ></sym-text>
        <sym-memo
          plain
          align="bottom"
          v-model="profile.address"
          caption="Address"
        ></sym-memo>

        <div v-if="isEngineer">
          <p class="lams text-center p-1 mb-1 curved mt-4">License</p>
          <sym-text
            plain
            align="bottom"
            v-model="profile.prcNumber"
            caption="PRC License Number"
          ></sym-text>

          <div class="equal-width">
            <sym-date
              plain
              align="bottom"
              v-model="profile.prcIssueDate"
              caption="Date Issued"
            ></sym-date>
            <sym-date
              plain
              align="bottom"
              v-model="profile.prcExpiryDate"
              caption="Expiry"
            ></sym-date>
          </div>

          <p class="lams text-center p-1 mb-1 curved mt-4">Tax Receipt</p>
          <sym-text
            plain
            align="bottom"
            v-model="profile.ptrNumber"
            caption="Receipt Number"
          ></sym-text>

          <div class="equal-width">
            <sym-date
              plain
              align="bottom"
              v-model="profile.ptrIssueDate"
              caption="Date Issued"
            ></sym-date>
            <sym-date
              plain
              align="bottom"
              v-model="profile.ptrExpiryDate"
              caption="Expiry"
            ></sym-date>
          </div>
        </div>

        <button
          type="button"
          class="success my-3 w-100 text-center lg-3 p-2 shadow-soft"
          @click="onSubmit"
        >
          <i class="fa fa-check mr-2"></i>Save
        </button>
        <button
          type="button"
          class="primary mb-3 w-100 text-center lg-2 p-1 shadow-soft"
          @click="goBack"
        >
          <i class="fa fa-arrow-left mr-2"></i>Back
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { DateTime } from "../../js/core";

import { get, ajax } from "../../js/http";

import PageBase from "../PageBase.vue";

const countDownSeconds = 150;
const buttonEnabledSeconds = 5;

export default {
  extends: PageBase,
  name: "lms1900",

  data() {
    return {
      profile: {
        accountCode: "",
        lastName: "",
        firstName: "",
        middleName: "",
        shortName: "",
        birthDate: null,
        email: "",
        phoneNumber: "",
        address: "",

        prcNumber: "",
        prcIssueDate: null,
        prcExpiryDate: null,

        ptrNumber: "",
        ptrIssueDate: null,
        ptrExpiryDate: null,
      },

      isSMSVerificationVisible: false,
      accountTypeId: 0,
      isFilled: false,

      OTP: "",
      requestedOTP: "",
      countDown: countDownSeconds,
    };
  },

  computed: {
    isEngineer() {
      return this.accountTypeId === 3;
    },

    isDisabled() {
      // return !this.profile.phoneNumber || this.buttonEnabled
      return this.countDown > buttonEnabledSeconds;
    },
  },

  methods: {
    loadData() {
      const me = this,
        wait = me.wait();

      me.getProfile().then(
        (info) => {
          me.stopWait(wait);
          if (info) {
            me.setModels(info);
            me.isFilled = true;
          }
        },
        (fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        }
      );
    },

    // API calls

    getProfile() {
      return get("api/accounts/" + this.accountCode);
    },

    updateProfile() {
      const me = this,
        p = me.profile;

      let payload = {
        lastName: p.lastName,
        firstName: p.firstName,
        middleName: p.middleName,
        shortName: p.shortName,
        birthDate: p.birthDate,
        email: p.email,
        phoneNumber: p.phoneNumber,
        address: p.address,
        prcNumber: p.prcNumber,
        prcIssueDate: p.prcIssueDate,
        prcExpiryDate: p.prcExpiryDate,
        ptrNumber: p.ptrNumber,
        ptrIssueDate: p.ptrIssueDate,
        ptrExpiryDate: p.ptrExpiryDate,
      };

      const body = JSON.stringify(payload),
        options = me.core.getAjaxOptions("PUT", body);

      return ajax("api/accounts/" + this.accountCode, options);
    },

    // event handlers

    onBirthDateChanging(e) {
      if (e.proposedValue instanceof DateTime) {
        let p = e.proposedValue,
          today = DateTime.now();

        if (p.year < 1930) {
          e.preventDefault();
          return;
        }

        if (p > today) {
          e.preventDefault();
          return;
        }
      }
    },

    onEmailChanging(e) {
      if (!this.core.isValidEmail(e.proposedValue)) {
        e.message = "(" + e.proposedValue + ") is not a valid email address.";
        e.preventDefault();
        return;
      }

      e.callback = this.emailCallback;
    },

    hideSMSVerificationDialog() {
      const me = this;

      me.isSMSVerificationVisible = false;
      me.stopCountDown();
    },

    onVerifyCode() {
      const me = this;
      let wait = me.wait();

      if (me.OTP.toString() !== me.requestedOTP.toString()) {
        me.advice.fault("Incorrect OTP.", { duration: 5 });
        me.stopWait(wait);
        return;
      }

      me.verifyPhoneNumber().then(
        (result) => {
          me.stopWait(wait);
          if (result) {
            me.dialog.success("Thank you for verifying you mobile number.");
            me.isSMSVerificationVisible = false;
            me.loadData();
          }
        },
        (fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        }
      );
      // me.verifyPhoneNumber();
    },

    verifyPhoneNumber() {
      const me = this,
        options = this.core.getAjaxOptions("PUT");

      return ajax("api/accounts/verify-phone/" + me.accountCode, options);
    },

    // onVerifyPhoneNumber () {
    //   const me = this;
    //   let wait = me.wait();

    //   me.isSMSVerificationVisible = true;

    //   me.InsertSMS().then(
    //     result => {
    //       me.stopWait(wait);
    //       if (result) {
    //         me.dialog.success('OTP message sent to your phonenumber.');
    //       }
    //     },
    //     fault => {
    //       me.stopWait(wait);
    //       me.showFault(fault);
    //     }
    //   );

    // },

    showSMSVerificationDialog() {
      const me = this;
      let wait = me.wait();

      me.isSMSVerificationVisible = true;

      me.InsertSMS().then(
        (result) => {
          me.stopWait(wait);
          if (result) {
            me.dialog.success("OTP message sent to your phonenumber.");
          }
        },
        (fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        }
      );
    },

    startCountDown() {
      const me = this;

      me.intervalId = setInterval(me.countDownHandler, 1000);
    },

    InsertSMS() {
      const me = this,
        phoneNumber = "+63" + me.profile.phoneNumber.substring(1, 11),
        // phoneNumber = me.phoneNumber,
        requestedOTP = Math.floor(1000 + Math.random() * 9000),
        message = "Your One-Time Password (OTP) is " + requestedOTP;

      me.requestedOTP = requestedOTP;
      me.buttonEnabled = true;

      if (!me.intervalId) {
        me.startCountDown();
      }

      let payload = {
        message: message,
        phoneNumber: phoneNumber,
      };

      const body = JSON.stringify(payload),
        options = me.core.getAjaxOptions("POST", body);

      return ajax("api/sms-notification", options);
    },

    countDownHandler() {
      const me = this;

      if (me.countDown === 0) {
        me.countDown = countDownSeconds;
        me.buttonEnabled = false;
        me.stopCountDown();
        return;
      }

      me.countDown -= 1;
    },

    stopCountDown() {
      const me = this;

      if (me.intervalId) {
        clearInterval(me.intervalId);
      }

      me.intervalId = 0;
    },

    onResendOTP() {
      const me = this;

      let wait = me.wait();

      me.InsertSMS().then(
        (result) => {
          me.stopWait(wait);
          if (result) {
            me.dialog.success("OTP message sent to your phonenumber.");
          }
        },
        (fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        }
      );
    },

    onResendConfirmation() {
      const me = this;

      let wait = me.wait();

      me.sendConfirmation().then(
        (result) => {
          me.stopWait(wait);
          if (result) {
            me.dialog.success("Verification message sent to your email.");
          }
        },
        (fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        }
      );
    },

    sendConfirmation() {
      const me = this,
        toEmail = me.profile.email,
        accountName = me.profile.accountName,
        verifyUrl =
          window.location.origin +
          "/verifier?email=" +
          me.profile.email +
          "&code=" +
          me.accountCode;

      // // eslint-disable-next-line no-console
      // console.log(me.profile.email);
      // eslint-disable-next-line no-console
      console.log(me.profile.email);

      let payload = {
        toEmail: toEmail,
        accountName: accountName,
        verifyUrl: verifyUrl,
      };

      const body = JSON.stringify(payload),
        options = me.core.getAjaxOptions("POST", body);

      return ajax("api/mails/confirmation", options);
    },

    emailCallback(e) {
      e.message =
        "Email '<b>" + e.proposedValue + "</b>' is already registered.";

      return this.isValidEntity(
        "dbo.WebAccount",
        "email",
        e.proposedValue,
        false
      ).then((result) => {
        return !result;
      });
    },

    onSubmit(nextRoute) {
      const me = this;

      if (!me.isValid(me.$options.name)) {
        me.advice.fault("Fill in the required fields (marked in red).", {
          duration: 5,
        });
        return;
      }

      if (me.hasChanges()) {
        const wait = me.wait();

        me.updateProfile()
          .then((success) => {
            me.stopWait(wait);
            if (success) {
              me.advice.success("Profile updated.", {
                duration: 4,
                dismissible: true,
              });
              me.refreshOldRefs();
              return me.sym.userInfo.restore();
            }
          })
          .then((success) => {
            if (success) {
              me.eventBus.$emit("user:changed");
              if (nextRoute && !(nextRoute instanceof MouseEvent)) {
                me.go(nextRoute);
              }
            }
          })
          .catch((fault) => {
            me.stopWait(wait);
            me.showFault(fault);
          });
      } else {
        me.loadData();
        me.advice.info(
          "No changes detected on save attempt.<hr>Profile record refreshed instead.",
          { duration: 4, dismissible: true }
        );
      }
    },

    // helpers

    setModels(info) {
      const me = this;

      me.profile = me.core.convertDates(info[0]);

      if (me.profile.birthDate === null) {
        me.profile.birthDate = me.core.emptyDateTime();
      }
      if (me.profile.prcIssueDate === null) {
        me.profile.prcIssueDate = me.core.emptyDateTime();
      }
      if (me.profile.prcExpiryDate === null) {
        me.profile.prcExpiryDate = me.core.emptyDateTime();
      }
      if (me.profile.ptrIssueDate === null) {
        me.profile.ptrIssueDate = me.core.emptyDateTime();
      }
      if (me.profile.ptrExpiryDate === null) {
        me.profile.ptrExpiryDate = me.core.emptyDateTime();
      }

      me.refreshOldRefs();
    },

    refreshOldRefs() {
      const me = this;

      me.oldProfile = JSON.stringify(me.profile);
    },

    hasChanges() {
      const me = this;
      return JSON.stringify(me.profile) !== me.oldProfile;
    },

    getPortalPagePath() {
      let page = "",
        typeId = this.accountTypeId;

      if (typeId === 1) {
        page = "lms1010";
      }
      if (typeId === 2) {
        page = "lms1020";
      }
      if (typeId === 3) {
        page = "lms1030";
      }
      if (typeId === 4) {
        page = "lms1040";
      }
      if (page) {
        return this.sym.getPath(page);
      }
      return "/";
    },

    setupControls() {
      const me = this;

      me.setRequiredMode(
        "laastName",
        "firstName",
        "middleName",
        "shortName",
        "birthDate",
        "phoneNumber",
        "address"
      );

      if (me.isEngineer) {
        me.setRequiredMode(
          "prcNumber",
          "prcIssueDate",
          "prcExpiryDate",
          "ptrNumber",
          "ptrIssueDate",
          "ptrExpiryDate"
        );
      }
    },
  },

  created() {
    const me = this;

    (me.accountCode = ""), (me.oldProfile = "");
  },

  mounted() {
    const me = this;

    me.accountCode = me.sym.userInfo.accountCode;
    me.accountTypeId = me.sym.userInfo.accountTypeId;
    me.dataConfig.models.push("profile");

    me.setupControls();
    me.loadData();

    me.$nextTick(() => {
      setTimeout(() => {
        me.setFocus("accountName");
      }, 250);
    });
  },

  beforeRouteLeave(to, from, next) {
    if (to.name === "fault") {
      next();
      return;
    }

    const me = this;
    if (me.hasChanges()) {
      me.dialog
        .confirmCancel(
          "You have unsaved changes to this record.<br>Save before leaving the page?",
          { scheme: "warning", icon: "warning", size: "md" }
        )
        .then((reply) => {
          if (reply === "yes") {
            me.onSubmit(to);
            next(false);
          } else if (reply === "cancel") {
            next(false);
          } else {
            next();
          }
        });
      return;
    }

    next();
  },
};
</script>

<style scoped>
.page-container {
  display: flex;
  /* background-image: linear-gradient( 240deg, rgb(116,235,213) 0%, rgb(63,43,150) 100%); */
}

.short-help-box {
  padding: 1rem 1.125rem;
}

.help-box {
  padding: 1.5rem 2rem;
}

.app-form {
  width: 42%;
  padding: 1rem 2rem;
}

.equal-width {
  display: flex;
}

.equal-width > * {
  flex: 1;
}

.equal-width > :not(:last-child) {
  margin-right: 0.5rem;
}

.equal-width :last-child {
  margin-right: 0;
}

@media (max-width: 1024px) {
  .app-form {
    width: 60%;
  }
}

@media (max-width: 800px) {
  .app-form {
    width: 70%;
  }
}

@media (max-width: 640px) {
  .app-form {
    width: 80%;
    padding: 1rem 1.25rem;
  }
}

@media (max-width: 480px) {
  .app-form {
    width: 90%;
  }
}

@media (max-width: 384px) {
  .app-form {
    padding: 0.75rem;
  }
}

@media (max-width: 320px) {
  .app-form {
    width: 96%;
    padding: 0.5rem;
  }
}
</style>
